import { useStaticQuery, graphql } from "gatsby"

export const LatestPostsData = () => {
  const { wpgraphql } = useStaticQuery(
    graphql`
      query latestPosts {
        wpgraphql {
          posts(first: 18) {
            nodes {
              title
              colourFeatureImage
              link
              tagWord {
                tagWord
              }
              date
              featuredImage {
                sourceUrl
                srcSet
                mediaDetails {
                  width
                  height
                }
              }
              avVideoTeaser {
                avVideoTeaser {
                  mediaItemUrl 
                }
              }
              excerpt
              categories(first: 3) {
                nodes {
                  name
                  slug
                }
              }
              avVideoTeaser {
								avVideoTeaser {
									mediaItemUrl
								}
						  }
            }
          }
        }
      }
    `
  )

  return wpgraphql
}
